import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@material-ui/core';
import translationPropType from '../../proptypes/translationPropType';
import { closeHelp } from '../../reduxStore/config/ui';

const Help = ({
    translation,
}) => {
    const open = useSelector(state => state.ui.helpOpen);

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(closeHelp);
    };

    return (
        <Dialog maxWidth="lg" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{translation.HELP_SECTION.HEADER}</DialogTitle>
            <DialogContent>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.INGRESS}
                </Typography>
                <Typography variant="h6" component="h6">
                    {translation.HELP_SECTION.SUBHEADER_1}
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.PARAGRAPH_1}
                </Typography>

                <Typography variant="h6" component="h6">
                    {translation.HELP_SECTION.SUBHEADER_2}
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.PARAGRAPH_2_1}
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.PARAGRAPH_2_2}
                </Typography>

                <Typography variant="h6" component="h6">
                    {translation.HELP_SECTION.SUBHEADER_3}
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.PARAGRAPH_3}
                </Typography>

                <Typography variant="h6" component="h6">
                    {translation.HELP_SECTION.SUBHEADER_4}
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.PARAGRAPH_4}
                </Typography>

                <Typography variant="h6" component="h6">
                    {translation.HELP_SECTION.SUBHEADER_5}
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    {translation.HELP_SECTION.PARAGRAPH_5}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {translation.CLOSE}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

Help.propTypes = {
    translation: translationPropType.isRequired,
};

export default Help;
